/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 */

// (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
// (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
// (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

/*
 * in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 * with the following flag, it will bypass `zone.js` patch for IE/Edge
 */
// (window as any).__Zone_enable_cross_context_check = true;
/** Evergreen browsers require these. * */
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
import 'core-js/es7/reflect';
/** *************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.

/** *************************************************************************************************
 * APPLICATION IMPORTS
 */

/**
 * Smoothscroll Polyfill to support .scrollBy() method
 * Using the given syntax due to: https://github.com/iamdustan/smoothscroll/issues/143#issuecomment-525673322
 */
/// <reference types="smoothscroll-polyfill" />
import * as smoothscroll from 'smoothscroll-polyfill';

/**
 * The Canvas to Blob polyfill is required for Edge browser while using the ngx-image-cropper:
 * https://github.com/Mawi137/ngx-image-cropper/issues/74#issuecomment-408603951
 */
import 'blueimp-canvas-to-blob/js/canvas-to-blob.min.js';

smoothscroll.polyfill();
